// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderInformationTitleStyle } from "@west/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { paymentMethodStyles } from "@west/App/Widgets/OrderDetails/OrderDetailsPaymentMethod";
import { css } from "styled-components";

paymentMethodStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

paymentMethodStyles.paymentTitle = {
    ...orderInformationTitleStyle.titleStyle,
};

paymentMethodStyles.paymentMethodTitleText = {
    variant: "h5",
    css: css`
        margin-bottom: 8px;
    `,
};

paymentMethodStyles.paymentMethodText = {
    size: 14,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        margin-bottom: 0;
        white-space: pre;
    `,
};
